<template>
  <div>
    <TextBox v-if="item.type == 'TextBox'" :data-field="item" />
    <ComboBox v-else-if="item.type == 'ComboBox'" :data-field="item"   :field-name="fieldName" />
    <TextField v-else-if="item.type == 'TextField'" :data-field="item" :field-name="fieldName" />
    <RatingBox v-else-if="item.type == 'RatingBox'" :data-field="item" :field-name="fieldName" />
    <SelectBox v-else-if="item.type == 'SelectBox'" :data-field="item" :field-name="fieldName" />
    <ToggleBox v-else-if="item.type == 'ToggleBox'" :data-field="item"/>
    <Slider v-else-if="item.type == 'Slider'" :data-field="item" />
    <TextArea v-else-if="item.type == 'TextArea'" :data-field="item" :field-name="fieldName" />
    <CheckBox v-else-if="item.type == 'CheckBox'" :data-field="item" :field-name="fieldName" />
    <FileInput v-else-if="item.type == 'FileInput'" :data-field="item" :field-name="fieldName" />
    <ReviewField v-else-if="item.type == 'ReviewField'" :data-field="item" />
    <IranPelakBox v-else-if="item.type == 'IranPelakBox'" :data-field="item" />
    <SahamsiDateBox v-else-if="item.type == 'SahamsiDateBox'" :data-field="item" :field-name="fieldName" /> 
    <MapPickerBox v-else-if="item.type == 'MapPickerBox'" :data-field="item" />
    <HtmlBox v-else-if="item.type == 'HtmlBox'" :data-field="item" />
    <ImageBox v-else-if="item.type == 'ImageBox'" :data-field="item" />
    <SubFormBox v-else-if="item.type == 'SubFormBox'" :data-field="item" />
    <p v-else style=" width: 100%; height: 50px; border: 1px solid #ccc; border-radius: 3px; " > <span style="color: #eee">{{ item.type }} ... {{ item.title }}</span> </p>
  </div>
</template>

<script>
import TextField from "../components/TextField.vue";
import RatingBox from "../components/RatingBox.vue";
import ComboBox from "../components/ComboBox.vue";
import SelectBox from "../components/SelectBox.vue";
import ToggleBox from "../components/ToggleBox.vue";
import Slider from "../components/Slider.vue";
import TextArea from "../components/TextArea.vue";
import TextBox from "../components/TextBox.vue";
import CheckBox from "../components/CheckBox.vue";
import FileInput from "../components/FileInput.vue";
import ReviewField from "../components/ReviewField.vue";
import IranPelakBox from "../components/IranPelakBox.vue";
import SahamsiDateBox from "../components/SahamsiDateBox.vue";
import MapPickerBox from "../components/MapPickerBox.vue";
import HtmlBox from "../components/HtmlBox.vue";
import ImageBox from "../components/ImageBox.vue";
import SubFormBox from "../components/SubFormBox.vue";

export default {
  name: "From",
  props: ["field","fieldName"],
  watch: {
    field: {
      handler : function(newValue){
        this.item = newValue
      },
      deep:true
    }
  },
  components: {
    TextField,
    RatingBox,
    ComboBox,
    SelectBox,
    ToggleBox,
    Slider,
    TextArea,
    TextBox,
    CheckBox,
    FileInput,
    ReviewField,
    IranPelakBox,
    SahamsiDateBox,
    MapPickerBox,
    HtmlBox,
    ImageBox,
    SubFormBox,
  },
  data: () => ({
    item : {}
  }),
  mounted() {
    this.item = this.field;
  }
};
</script>

<style>
</style>